import { TFunction } from "i18next";
import { Text } from "@pentabd/ui";

import TableActions from "@components/TableActions";
import { StatusType } from "@type/taskManagement/settings/status";

export const StatusTableColumn = (
  t: TFunction<"translation", undefined>,
  handleQueryById: (id: string | number) => void,
  openConfirmationModel: (itemName: string, id: string | number) => void,
) => {
  return [
    {
      id: 1,
      key: "name",
      name: t("TM_SETTINGS.STATUS.TABLE.COLUMN.STATUS_NAME"),
      render: (name: string) => <Text color="subtitle2">{name}</Text>,
    },
    {
      id: 2,
      key: "id",
      name: "",
      render: (id: string | number, row: StatusType) => {
        return (
          <TableActions
            onClickEdit={() => {
              handleQueryById(id);
            }}
            onClickDelete={() => {
              openConfirmationModel(row?.name, id);
            }}
          />
        );
      },
    },
  ];
};
